import React, { useId } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, useTheme } from "@mui/material";
import { X, Check, AlertTriangle } from "lucide-react";
import confirmationImage from "../assets/SystemSettings/Confirmimg.svg";

const ConfirmationDialog = ({
  open, onClose, onConfirm, title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Delete", cancelText = "Cancel", isDangerous = false,
}) => {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const titleId = useId();
  const messageId = useId();
  const brand = dark ? "#A66FFF" : "#4B1498";
  const ink = dark ? "#f3f0fa" : "#191F2D";
  const handleConfirm = () => { onConfirm(); onClose(); };
  const buttonStyle = {
    minHeight: 52, borderRadius: "9px", textTransform: "none", fontSize: 16,
    fontWeight: 600, px: 3, gap: 1, boxShadow: "none",
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm"
      aria-labelledby={titleId} aria-describedby={messageId}
      PaperProps={{ sx: { width: "100%", maxWidth: 672, m: { xs: 2, sm: 4 },
        borderRadius: "10px", background: dark ? "#232137" : "#fff",
        color: ink, border: "1px solid", borderColor: dark ? "#3d3657" : "#e8e5ee",
        boxShadow: "0 20px 70px rgba(25,31,45,.18)" } }}>
      <DialogTitle id={titleId} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 2, py: 1.5, pl: 2.5, pr: 2, borderBottom: "1px solid", borderColor: dark ? "#3d3657" : "#e8e5ee",
        fontSize: 18, fontWeight: 500, lineHeight: 1.4, color: ink }}>
        <span>{title}</span>
        <IconButton onClick={onClose} aria-label="Close confirmation" size="small" sx={{ color: ink, flexShrink: 0 }}><X size={23}/></IconButton>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", px: { xs: 3, sm: 5 }, pt: "20px !important", pb: 1 }}>
        <img src={confirmationImage} alt="" aria-hidden="true" style={{ display: "block", width: 176, height: 105, objectFit: "contain", margin: "0 auto 20px" }}/>
        <Typography id={messageId} sx={{ fontSize: { xs: 16, sm: 18 }, lineHeight: 1.3, color: ink, maxWidth: 510, mx: "auto" }}>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", flexWrap: "wrap", gap: 2, px: 3, pt: 3.5, pb: 3.5, "& > :not(style) ~ :not(style)": { ml: 0 } }}>
        <Button onClick={onClose} variant="outlined" startIcon={<X size={19}/>} sx={{ ...buttonStyle, color: brand, borderColor: brand,
          "&:hover": { borderColor: "#A66FFF", background: dark ? "#302644" : "#F0EBFF" } }}>{cancelText}</Button>
        <Button onClick={handleConfirm} variant="contained" startIcon={isDangerous ? <AlertTriangle size={18}/> : <Check size={19}/>} sx={{ ...buttonStyle,
          background: isDangerous ? "#dc2626" : "#4B1498", color: "#fff", minWidth: 194,
          "&:hover": { background: isDangerous ? "#b91c1c" : "#651cbc", boxShadow: "none" } }}>{confirmText}</Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmationDialog;
